<template>
<BaseFixCenter class="monit_box" w="1000" h="660" title="监播服务" v-model="visible">
  <template v-slot:default>
    <el-tabs v-model="monitTab" class="monit_tab_area">
      <!-- 摄像头截图tab-pane需使用延迟渲染（可以理解为v-if模式）才能保证截图日期文字提示的正确展示 -->
      <!-- <el-tab-pane name="camera" lazy>
        <div slot="label" class="tab_title">摄像头截图</div>
        <ShotCamera :orderInfo="orderInfo" @complete="$emit('update:show', false)"></ShotCamera>
      </el-tab-pane> -->
      <el-tab-pane name="screen">
        <div slot="label" class="tab_title">监播截图</div>
        <ShotScreen :orderInfo="orderInfo" @complete="$emit('update:show', false)"></ShotScreen>
      </el-tab-pane>
      <el-tab-pane name="tasks">
        <div slot="label" class="tab_title">任务列表<span v-if="taskInfo.totalTask > 0">({{taskInfo.finishTask}}/{{taskInfo.totalTask}})</span></div>
        <TaskList ref="monitTasks" :orderInfo="orderInfo" @changeTaskInfo="changeTaskInfo"></TaskList>
      </el-tab-pane>
    </el-tabs>
  </template>
  <template #footer>
    <div class="footer-button" @click="$emit('update:show', false)">关闭</div>
  </template>
</BaseFixCenter>
</template>

<script>
// import ShotCamera from './MonitShotCamera'
import ShotScreen from './MonitShotScreen'
import TaskList from './MonitTaskList'

export default {
  name: 'MonitPopper',
  components: { ShotScreen, TaskList },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    orderInfo: {
      type: Object,
      default () { return {} }
    }
  },
  data () {
    return {
      monitTab: 'screen',
      taskInfo: {
        finishTask: 0,
        totalTask: 0
      }
    }
  },
  computed: {
    visible: {
      get () {
        return this.show
      },
      set (v) {
        this.$emit('update:show', v)
      }
    }
  },
  watch: {
    monitTab (nt, ot) {
      if (nt === 'tasks') {
        if (this.$refs.monitTasks && this.$refs.monitTasks.getTaskList) {
          this.$refs.monitTasks.getTaskList()
        }
      } else { // 切回屏幕/相机截图tab时发出事件，通知地区选择控件更新已选项渲染长度的计算
        this.$root.$emit('refreshCheckedZone')
      }
    }
  },
  methods: {
    changeTaskInfo (data) {
      this.taskInfo = data
    }
  }
}
</script>

<style lang="scss" scoped>
.monit_tab_area {
  height: 100%;
  ::v-deep .el-tabs__header {
    background-color: #fff;
    margin-bottom: 0;
    .el-tabs__nav-wrap {
      &::after {
        height: 1px;
        background-color: #E9E9E9;
      }
      .el-tabs__nav {
        text-align: center;
        width: 100%;
        .el-tabs__active-bar {
          display: none;
        }
        .el-tabs__item {
          color: #999999;
          display: inline-block;
          padding: 0;
          width: 33.3%;
          box-sizing: content-box;
          &:not(:last-child) {
            &:after {
              background: #E9E9E9;
              content: '';
              width: 1px;
              height: 20px;
              position: absolute;
              right: 0;
              top: 50%;
              transform: translateY(-50%);
            }
          }
          &.is-active {
            color: #282729;
            .tab_title {
              display: inline-block;
              border-bottom: 1px solid #282729;
              height: 100%;
            }
          }
        }
      }
    }
  }
  ::v-deep .el-tabs__content {
    height: calc(100% - 40px);
    .el-tab-pane {
      height: 100%;
    }
  }
}
.monit_box {
  ::v-deep .fix_dialog__center .fix_dialog_footer {
    border-top: none;
  }
}
</style>
